import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TEST_ACTIVATION_ROUTE } from 'core/constants/activationTest';
import { useActivationTestMode } from 'core/context/ActivationTestMode';
import useLocales from 'hooks/useLocales';

const FLOW_LABEL: Record<string, string> = {
  candidate: 'Candidate',
  company: 'Company',
  recruiter: 'Recruiter'
};

const TestActivationBanner = (): JSX.Element => {
  const { t } = useLocales();
  const { flow } = useActivationTestMode();
  const navigate = useNavigate();

  return (
    <div className="test-activation-banner">
      <span>
        {t('Test mode')} — {FLOW_LABEL[flow] || flow} {t('onboarding')}.{' '}
        {t('Nothing is saved to this account.')}
      </span>
      <div className="test-activation-banner__actions">
        <button
          type="button"
          className="test-activation-banner__btn"
          onClick={() => navigate(TEST_ACTIVATION_ROUTE)}
        >
          {t('Change flow')}
        </button>
      </div>
    </div>
  );
};

export default TestActivationBanner;
